module.exports = __webpack_public_path__ + "img/uf-truck.688cc308.jpg";